import axios from 'axios'

export function setSessionStorage (key, value) {
  const data = JSON.parse(sessionStorage.getItem('vue-session-key'))
  data[key] = value
  sessionStorage.setItem('vue-session-key', JSON.stringify(data))
}

export function getSessionStorage (key) {
  const data = JSON.parse(sessionStorage.getItem('vue-session-key'))
  return data[key]
}

export function getToken () {
  return getSessionStorage('token')
}

export function getUser () {
  return {
    email: atob(getSessionStorage('email')),
    password: getSessionStorage('pass')
  }
}

function parseJwt (token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
    return `%${  (`00${  c.charCodeAt(0).toString(16)}`).slice(-2)}`
  }).join(''))
  return JSON.parse(jsonPayload)
}

export function setToken (token) {
  const jwt = parseJwt(token)
  setSessionStorage('expirationDate', jwt.u.expirationDate)
  setSessionStorage('jwt', token)
}

export function validateToken () {
  const token = getToken()
  if (token !== null) {    
    const expirationDate = new Date(getSessionStorage('expirationDate'))
    const today = new Date()
    if (expirationDate < today) {
      return false
    } else {
      return true
    }
  } else return false
}

export async function generateToken () {
  return new Promise(resolve => {
    const user = getUser()
    axios.post(`${process.env.VUE_APP_API_URL || ''}login`, user).then(res => {
      if (res.status === 200) {  
        setToken(res.data.data)
        resolve(getToken())
      }
    })
  })
}